import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Logo } from "../Header";
import { api, errMsg, setAdminToken } from "../../lib/api";

export const AdminLogin = ({ onDone }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setAdminToken(data.token);
      onDone();
    } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };
  const input = "mt-1 w-full border-2 border-slate-200 px-3 py-2.5 text-sm font-semibold outline-none focus:border-slate-900";
  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <form onSubmit={submit} className="w-full max-w-sm space-y-4 border-2 border-slate-900 bg-white p-6 shadow-[6px_6px_0_0_#0f172a]" data-testid="admin-login-form">
        <Logo />
        <h1 className="font-display text-2xl font-black uppercase">Admin sign in</h1>
        <label className="block text-xs font-bold uppercase tracking-wider text-slate-600">Email
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={input} data-testid="admin-email-input" />
        </label>
        <label className="block text-xs font-bold uppercase tracking-wider text-slate-600">Password
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={input} data-testid="admin-password-input" />
        </label>
        {error && <p className="text-sm text-red-600" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy} className="btn-blaze flex w-full items-center justify-center gap-2 px-4 py-2.5 text-sm" data-testid="admin-login-button">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </button>
      </form>
    </div>
  );
};
